import { render, staticRenderFns } from "./UserApprove.vue?vue&type=template&id=1c4728f8&scoped=true"
import script from "./UserApprove.vue?vue&type=script&lang=js"
export * from "./UserApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4728f8",
  null
  
)

export default component.exports